import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

// // VACANCYTITLES
export const vacancytitleCreate = (params = '') => Http.post('/vacancies-titles', params)
// // // LIST ALL VACANCYTITLES
export const vacancytitlesList = (params = '') => Http.get(`/vacancies-titles${serialize(params)}`)
// // // GET VACANCYTITLE BY ID
export const vacancytitleByID = (params = '') => Http.get(`/vacancies-titles/${params}`)
// // // UPDATE VACANCYTITLE
export const vacancytitleUpdate = (params = '') => Http.put(`/vacancies-titles/${params.id}`, params)
// // // DELETE VACANCYTITLE
export const vacancytitleDestroy = (params = '') => Http.delete(`/vacancies-titles/${params.id}`)
